/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */


/**
 * The ConceptsFetcherFeature
 **/

define([
	'dashboard-analytics/visualizations/renderer/sequence/BaseTask'
], function(
	BaseTask
) {
	'use strict';

	var SmartColorRenderStep = BaseTask.extend({

		init: function(options, moduleOptions) {
			SmartColorRenderStep.inherited('init', this, arguments);

			this.smartColorMapAPI = moduleOptions.smartColorMapAPI;
		},

		/**
		 * Load the visControl (if any) and store in the visControl member of the renderContext.
		 * @param renderContext - information collected by a particular call to render or reRender (such as the view, control, data etc).
		 * @returns a promise
		 */
		process: function(renderContext) {
			if (this._isStepComplete(renderContext, 'smartColorMapRenderStep')) {
				return Promise.resolve(renderContext);
			}else{
				return this._setupColorMap(renderContext).then((concepts) => {
					this._completeStep(renderContext, 'smartColorMapRenderStep', concepts);
					return renderContext;
				}).catch(() => {
					return renderContext;
				});
			}
		},

		_setupColorMap: function( /*renderContext*/ ) {
			//get list of all slots related to color, get mapped column ids
			//if there are 'color' columns
			//	get SmartColor feature
			//	return invoke SmartColor.setupColorMap(datasource id, columnIds)
			//else
			// return resolve( true ) //go to the next step

			//TEMP change:  VIDA calls getColor() callback for point, line chart even when color slot is not filled (not expected)
			//_hasColorSlot() will return false in this case and FredIsRed won't be initialized - causing failures
			//_hasColorSlot() check is really needed when integrating with smarts so that we avoid cost of calling smarts
			//currently smarts functionality is not available, so while issue is addressed with VIDA, we can disable the check
			//if ( this._hasColorSlot() ) {
				const visFeature = this.content.getFeature('Visualization');
				const datasource = visFeature && visFeature.getDataSource();
				const datasourceId = datasource && datasource.getAssetId();

				if( datasourceId ) {
					return this.smartColorMapAPI.setupColorMap( datasourceId, visFeature.getDataSource().getType() );
				} else {
					return Promise.resolve(true);
				}

			// }
			// return Promise.resolve(true);
		},

		_hasColorSlot: function() {
			let canUseSlotToColor = true;

			const visFeature = this.content.getFeature('Visualization');
			const slots = visFeature && visFeature.getSlots();
			const mappedSlots = slots && slots.getMappedSlotList();
			canUseSlotToColor = mappedSlots && mappedSlots.some( ( slot ) => {
				const defn = slot.getDefinition();
				const tags = defn && defn.getTags() || [];
				return tags.includes('canUseToColor');
			});

			return canUseSlotToColor;
		}
	});

	return SmartColorRenderStep;
});
